<template>
  <div>
    <AppNavbar />
    <div class="container-fluid mt-4 px-3 px-xl-4">
      <AppHeader title="E-Pedidos">
        <template #buttons>
          <router-link class="btn btn-outline-secondary" to="/gestion-pedidos">
            Volver a Pedidos
          </router-link>
        </template>
      </AppHeader>

      <div v-if="!canManageEcommerce" class="alert alert-warning mb-0">
        Esta sección está disponible sólo para usuarios con el permiso <code>gestionar_ecommerce</code>.
      </div>

      <template v-else>
        <p class="text-muted">
          Pedidos que llegaron por el canal de ecommerce. Atender un e-pedido lo convierte en un
          pedido interno, listo para completar y enviar a caja desde Pedidos. Un pedido que no se
          va a atender se descarta con un motivo y queda registrado.
        </p>

        <div class="row g-2 align-items-end mb-3">
          <div class="col-md-5">
            <label class="form-label small text-muted mb-1" for="epedidosBuscar">Buscar</label>
            <input
              id="epedidosBuscar"
              v-model="searchInput"
              type="text"
              class="form-control"
              placeholder="Buscar por nombre, documento, celular o email..."
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1" for="epedidosEstado">Estado</label>
            <select id="epedidosEstado" v-model="estadoFiltro" class="form-select">
              <option value="pendientes">Pendientes</option>
              <option value="atendidos">Atendidos</option>
              <option value="descartados">Descartados</option>
              <option value="todos">Todos</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label small text-muted mb-1" for="epedidosOrden">Ordenar por</label>
            <select id="epedidosOrden" v-model="ordenFiltro" class="form-select">
              <option value="antiguos">Más viejos primero</option>
              <option value="recientes">Más recientes primero</option>
              <option value="monto_desc">Monto: mayor a menor</option>
              <option value="monto_asc">Monto: menor a mayor</option>
            </select>
          </div>
        </div>

        <div class="card shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="h5 mb-0">{{ tituloLista }}</h2>
              <small class="text-muted">{{ totalPedidos }} pedido(s)</small>
            </div>

            <div class="table-responsive">
              <table class="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Documento</th>
                    <th>Contacto</th>
                    <th>Ítems</th>
                    <th>Total</th>
                    <th>Entrega</th>
                    <th>Recibido</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="cargando">
                    <td colspan="9" class="text-center py-4">Cargando e-pedidos...</td>
                  </tr>
                  <tr v-else-if="!pedidosWeb.length">
                    <td colspan="9" class="text-center py-4">{{ mensajeVacio }}</td>
                  </tr>
                  <tr
                    v-for="pedidoWeb in pedidosWeb"
                    :key="pedidoWeb.pedido_online_id"
                    class="epedido-fila"
                    @click="abrirDetalle(pedidoWeb)"
                  >
                    <td>{{ pedidoWeb.contacto?.nombre || 'Cliente ecommerce' }}</td>
                    <td>{{ pedidoWeb.contacto?.numero_documento || '—' }}</td>
                    <td>
                      <div>{{ pedidoWeb.contacto?.telefono || '—' }}</div>
                      <small class="text-muted">{{ pedidoWeb.contacto?.email || '' }}</small>
                    </td>
                    <td>{{ pedidoWeb.items?.length || 0 }}</td>
                    <td>{{ formatearMonto(pedidoWeb.subtotal) }}</td>
                    <td>{{ pedidoWeb.modo_entrega === 'ENVIO' ? 'Envío' : 'Retiro' }}</td>
                    <td>{{ formatearFecha(pedidoWeb.creado_en) }}</td>
                    <td>
                      <span :class="['badge', claseEstado(pedidoWeb)]">{{ etiquetaEstado(pedidoWeb) }}</span>
                      <div v-if="esDescartadoRow(pedidoWeb) && pedidoWeb.descartado_motivo" class="small text-muted mt-1" style="max-width: 18rem;">
                        {{ pedidoWeb.descartado_motivo }}
                        <span v-if="pedidoWeb.descartado_por_nombre">— {{ pedidoWeb.descartado_por_nombre }}</span>
                      </div>
                    </td>
                    <td>
                      <div v-if="esPendiente(pedidoWeb)" class="d-flex gap-1 align-items-center">
                        <button
                          type="button"
                          class="btn btn-outline-dark btn-sm"
                          :disabled="importandoPedidoWebId === pedidoWeb.pedido_online_id"
                          @click.stop="atenderPedidoWeb(pedidoWeb.pedido_online_id)"
                        >
                          {{ importandoPedidoWebId === pedidoWeb.pedido_online_id ? 'Atendiendo...' : 'Atender' }}
                        </button>
                        <div class="dropdown">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm epedido-acciones"
                            :disabled="importandoPedidoWebId === pedidoWeb.pedido_online_id"
                            :aria-expanded="menuAbiertoId === pedidoWeb.pedido_online_id ? 'true' : 'false'"
                            aria-haspopup="menu"
                            title="Más acciones"
                            @click.stop="alternarMenu(pedidoWeb.pedido_online_id)"
                          >
                            <i class="bi bi-three-dots-vertical"></i>
                          </button>
                          <ul
                            v-if="menuAbiertoId === pedidoWeb.pedido_online_id"
                            class="dropdown-menu show epedido-menu"
                            role="menu"
                          >
                            <li>
                              <button
                                type="button"
                                role="menuitem"
                                class="dropdown-item"
                                @click.stop="abrirDetalle(pedidoWeb)"
                              >
                                <i class="bi bi-eye me-2"></i>Ver detalle
                              </button>
                            </li>
                            <li><hr class="dropdown-divider"></li>
                            <li>
                              <button
                                type="button"
                                role="menuitem"
                                class="dropdown-item text-danger"
                                @click.stop="abrirDescarte(pedidoWeb)"
                              >
                                <i class="bi bi-x-circle me-2"></i>Descartar pedido
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div v-else-if="esDescartadoRow(pedidoWeb)" class="dropdown">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm epedido-acciones"
                          :disabled="revirtiendoId === pedidoWeb.pedido_online_id"
                          :aria-expanded="menuAbiertoId === pedidoWeb.pedido_online_id ? 'true' : 'false'"
                          aria-haspopup="menu"
                          title="Más acciones"
                          @click.stop="alternarMenu(pedidoWeb.pedido_online_id)"
                        >
                          <i class="bi bi-three-dots-vertical"></i>
                        </button>
                        <ul
                          v-if="menuAbiertoId === pedidoWeb.pedido_online_id"
                          class="dropdown-menu show epedido-menu"
                          role="menu"
                        >
                          <li>
                            <button
                              type="button"
                              role="menuitem"
                              class="dropdown-item"
                              @click.stop="abrirDetalle(pedidoWeb)"
                            >
                              <i class="bi bi-eye me-2"></i>Ver detalle
                            </button>
                          </li>
                          <li><hr class="dropdown-divider"></li>
                          <li>
                            <button
                              type="button"
                              role="menuitem"
                              class="dropdown-item"
                              :disabled="revirtiendoId === pedidoWeb.pedido_online_id"
                              @click.stop="revertirDescarte(pedidoWeb)"
                            >
                              <i class="bi bi-arrow-counterclockwise me-2"></i>
                              {{ revirtiendoId === pedidoWeb.pedido_online_id ? 'Devolviendo...' : 'Devolver a pendientes' }}
                            </button>
                          </li>
                        </ul>
                      </div>
                      <span v-else class="text-muted small">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <AppPagination
              :currentPage="paginaActual"
              :totalPages="totalPaginas"
              @page-changed="cambiarPagina"
            />
          </div>
        </div>
      </template>
    </div>

    <EPedidoDetalleModal :pedido="pedidoDetalle" @close="pedidoDetalle = null" />

    <AppModal
      modalId="descartarEpedidoModal"
      :showModal="!!pedidoADescartar"
      title="Descartar e-pedido"
      withBackdrop
      @close="cerrarDescarte"
    >
      <template #body>
        <p class="mb-2">
          Vas a descartar el pedido de
          <strong>{{ pedidoADescartar?.contacto?.nombre || 'Cliente ecommerce' }}</strong>
          por {{ formatearMonto(pedidoADescartar?.subtotal) }}.
        </p>
        <p class="text-muted small">
          El pedido sale de la lista de pendientes pero no se borra: queda el registro de qué pidió
          el cliente y por qué se descartó. Esta acción no se puede deshacer desde acá.
        </p>
        <label class="form-label" for="motivoDescarte">Motivo <span class="text-danger">*</span></label>
        <textarea
          id="motivoDescarte"
          v-model="motivoDescarte"
          class="form-control"
          rows="3"
          maxlength="500"
          placeholder="Ej: el cliente canceló por WhatsApp / pedido duplicado / no responde"
        ></textarea>
        <div class="d-flex justify-content-between mt-1">
          <small v-if="errorDescarte" class="text-danger">{{ errorDescarte }}</small>
          <small v-else class="text-muted">Mínimo 3 caracteres.</small>
          <small class="text-muted">{{ motivoDescarte.length }} / 500</small>
        </div>
      </template>
      <template #footer>
        <button type="button" class="btn btn-outline-secondary" :disabled="descartando" @click="cerrarDescarte">
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-danger"
          :disabled="descartando || motivoDescarte.trim().length < 3"
          @click="confirmarDescarte"
        >
          {{ descartando ? 'Descartando…' : 'Descartar pedido' }}
        </button>
      </template>
    </AppModal>
  </div>
</template>

<script>
import AppNavbar from '../components/AppNavbar.vue';
import AppHeader from '../components/AppHeader.vue';
import AppPagination from '../components/AppPagination.vue';
import AppModal from '../components/AppModal.vue';
import EPedidoDetalleModal from '../components/EPedidoDetalleModal.vue';
import operationalConfigService from '../services/operationalConfigService.js';
import pedidoOnlineService from '../services/pedidoOnlineService.js';
import { hasPermission } from '../services/authSessionService.js';

// Pedidos > E-Pedidos (RF-7 corregido de SPEC_ECOMMERCE_CUENTAS_v0.1.md,
// Ampliación 2026-07-30): subsección paginada y filtrable, separada de la
// pantalla de Pedidos internos — "atender" un e-pedido lo importa como
// pedido interno vía Orders.createOrder sin tocar esa lógica.
export default {
  name: 'EPedidosView',
  components: {
    AppNavbar,
    AppHeader,
    AppPagination,
    AppModal,
    EPedidoDetalleModal
  },
  data() {
    return {
      pedidosWeb: [],
      searchInput: '',
      estadoFiltro: 'pendientes',
      ordenFiltro: 'antiguos',
      paginaActual: 1,
      itemsPorPagina: 10,
      totalPaginas: 1,
      totalPedidos: 0,
      cargando: false,
      importandoPedidoWebId: null,
      menuAbiertoId: null,
      pedidoDetalle: null,
      revirtiendoId: null,
      pedidoADescartar: null,
      motivoDescarte: '',
      descartando: false,
      errorDescarte: ''
    };
  },
  computed: {
    canManageEcommerce() {
      return hasPermission('gestionar_ecommerce');
    },
    currentSucursalId() {
      return operationalConfigService.getCurrentSucursalId();
    },
    tituloLista() {
      return {
        pendientes: 'E-Pedidos pendientes',
        atendidos: 'E-Pedidos atendidos',
        descartados: 'E-Pedidos descartados',
        todos: 'Todos los e-pedidos'
      }[this.estadoFiltro] || 'E-Pedidos';
    },
    mensajeVacio() {
      if ((this.searchInput || '').trim()) return 'Ningún e-pedido coincide con la búsqueda.';
      return {
        pendientes: 'No hay e-pedidos pendientes.',
        atendidos: 'Todavía no se atendió ningún e-pedido.',
        descartados: 'No hay e-pedidos descartados.',
        todos: 'No hay e-pedidos.'
      }[this.estadoFiltro] || 'No hay e-pedidos.';
    }
  },
  watch: {
    async searchInput() {
      await this.reiniciarBusqueda();
    },
    async estadoFiltro() {
      await this.reiniciarBusqueda();
    },
    async ordenFiltro() {
      await this.reiniciarBusqueda();
    }
  },
  mounted() {
    if (this.canManageEcommerce) {
      this.cargarPedidosWeb();
    }
    // Cerrar el menú de acciones al hacer clic afuera. Sin esto queda abierto
    // hasta que el operador vuelve a apretar los tres puntos, y con varias
    // filas se acumulan menús abiertos.
    document.addEventListener('click', this.cerrarMenu);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.cerrarMenu);
  },
  methods: {
    async cargarPedidosWeb({ page = this.paginaActual } = {}) {
      this.cargando = true;
      try {
        const { pedidos, paginacion } = await pedidoOnlineService.listPendientes({
          page,
          limit: this.itemsPorPagina,
          q: (this.searchInput || '').trim(),
          estado: this.estadoFiltro,
          orden: this.ordenFiltro
        });
        this.pedidosWeb = pedidos;
        this.paginaActual = Number(paginacion.page || page) || 1;
        this.totalPaginas = Number(paginacion.totalPages || 1) || 1;
        this.totalPedidos = Number(paginacion.total || pedidos.length) || pedidos.length;
      } catch (error) {
        console.error('Error cargando e-pedidos', error);
        this.pedidosWeb = [];
        this.totalPaginas = 1;
        this.totalPedidos = 0;
      } finally {
        this.cargando = false;
      }
    },
    async cambiarPagina(page) {
      if (page === this.paginaActual) return;
      this.paginaActual = page;
      await this.cargarPedidosWeb({ page });
    },
    async atenderPedidoWeb(pedidoOnlineId) {
      this.importandoPedidoWebId = pedidoOnlineId;
      try {
        const resultado = await pedidoOnlineService.importar(pedidoOnlineId, this.currentSucursalId);
        // RF-8a: atender lleva directo a Pedidos, con el pedido recién creado
        // abierto en el panel. La atención es de a uno a propósito (decisión
        // del usuario, 2026-08-19): no agregar modo tanda ni quitar esto.
        //
        // Sólo se navega con `ver_pedidos_pendientes`: E-Pedidos se gatea con
        // `gestionar_ecommerce`, que no es el mismo conjunto. Sin el permiso,
        // el guard de router rebotaría al operador a /pantalla-inicio, que es
        // peor que no navegar.
        const puedeIrAPedidos = hasPermission('ver_pedidos_pendientes');
        if (puedeIrAPedidos) {
          window.alert.success(`E-pedido atendido como pedido #${resultado.pedido_id}.`);
          this.$router.push({ path: '/gestion-pedidos', query: { pedido_id: resultado.pedido_id } });
          return;
        }
        window.alert(`E-pedido atendido como pedido #${resultado.pedido_id}. Podés revisarlo y confirmarlo desde Pedidos.`);
        await this.cargarPedidosWeb();
      } catch (error) {
        console.error('Error atendiendo e-pedido', error);
        window.alert(this.mensajeErrorAtender(error));
      } finally {
        this.importandoPedidoWebId = null;
      }
    },
    // Bug de auditoría (2026-08-09, antes de commitear): cuando el backend
    // rechaza líneas de un e-pedido (ej. un granel con menos de 10 gramos),
    // devuelve el detalle exacto por línea —producto y motivo— en
    // `errores`. Esta pantalla lo descartaba y mostraba solo el mensaje
    // genérico del wrapper ("El pedido tiene líneas que no se pueden
    // atender"), sin decir cuál producto ni por qué. Es exactamente la
    // opacidad del incidente original que motivó todo el arreglo de granel
    // (cinco reintentos ciegos con el mismo error sin pista). El
    // componente de notificación no soporta saltos de línea (`<p>` sin
    // `white-space: pre-line`), así que los errores se unen con " · " en
    // vez de "\n".
    mensajeErrorAtender(error) {
      const errores = error?.response?.data?.errores;
      if (Array.isArray(errores) && errores.length) {
        const detalle = errores
          .map((e) => `${e.nombre || `Producto #${e.producto_id}`}: ${e.motivo}`)
          .join(' · ');
        return `No se pudo atender el pedido — ${detalle}`;
      }
      return error?.response?.data?.message || 'No se pudo atender el e-pedido';
    },
    async reiniciarBusqueda() {
      this.paginaActual = 1;
      await this.cargarPedidosWeb({ page: 1 });
    },
    // Un e-pedido pendiente es el que todavía no fue ni atendido ni
    // descartado: `estado_importacion` en null. Es el único sobre el que
    // tienen sentido las acciones.
    esPendiente(pedidoWeb) {
      return !pedidoWeb?.estado_importacion;
    },
    esDescartadoRow(pedidoWeb) {
      return pedidoWeb?.estado_importacion === 'descartado';
    },
    etiquetaEstado(pedidoWeb) {
      if (pedidoWeb?.estado_importacion === 'importado') return 'Atendido';
      if (pedidoWeb?.estado_importacion === 'descartado') return 'Descartado';
      return 'Pendiente';
    },
    claseEstado(pedidoWeb) {
      if (pedidoWeb?.estado_importacion === 'importado') return 'text-bg-success';
      if (pedidoWeb?.estado_importacion === 'descartado') return 'text-bg-secondary';
      return 'text-bg-warning';
    },
    async revertirDescarte(pedidoWeb) {
      const nombre = pedidoWeb.contacto?.nombre || 'Cliente ecommerce';
      this.menuAbiertoId = null;
      // Confirmación previa (RF-7): revertir saca al pedido de "descartado" y
      // lo devuelve a la cola de trabajo real, así que merece el mismo
      // cuidado que descartarlo.
      //
      // `window.confirm` está sobreescrito en main.js por un diálogo propio
      // (confirmStore) que devuelve una Promise, no un booleano — hay que
      // esperarlo con `await`. Sin eso, `!promise` da siempre `false` (una
      // Promise es un objeto, y los objetos son truthy) y el revert se
      // ejecutaría de inmediato sin esperar la respuesta real del operador.
      const confirmado = await window.confirm(`¿Devolver el pedido de ${nombre} a la cola de pendientes?`);
      if (!confirmado) return;
      this.revirtiendoId = pedidoWeb.pedido_online_id;
      try {
        await pedidoOnlineService.revertirDescarte(pedidoWeb.pedido_online_id);
        await this.cargarPedidosWeb();
      } catch (error) {
        console.error('Error revirtiendo descarte', error);
        window.alert(error?.response?.data?.message || 'No se pudo devolver el pedido a pendientes.');
      } finally {
        this.revirtiendoId = null;
      }
    },
    abrirDetalle(pedidoWeb) {
      this.menuAbiertoId = null;
      this.pedidoDetalle = pedidoWeb;
    },
    alternarMenu(pedidoOnlineId) {
      this.menuAbiertoId = this.menuAbiertoId === pedidoOnlineId ? null : pedidoOnlineId;
    },
    cerrarMenu() {
      this.menuAbiertoId = null;
    },
    abrirDescarte(pedidoWeb) {
      this.menuAbiertoId = null;
      this.pedidoADescartar = pedidoWeb;
      this.motivoDescarte = '';
      this.errorDescarte = '';
    },
    cerrarDescarte() {
      if (this.descartando) return;
      this.pedidoADescartar = null;
      this.motivoDescarte = '';
      this.errorDescarte = '';
    },
    async confirmarDescarte() {
      const motivo = this.motivoDescarte.trim();
      if (motivo.length < 3) {
        this.errorDescarte = 'El motivo es obligatorio (mínimo 3 caracteres).';
        return;
      }
      this.descartando = true;
      this.errorDescarte = '';
      try {
        await pedidoOnlineService.descartar(this.pedidoADescartar.pedido_online_id, motivo);
        this.pedidoADescartar = null;
        this.motivoDescarte = '';
        await this.cargarPedidosWeb();
      } catch (error) {
        console.error('Error descartando e-pedido', error);
        this.errorDescarte = error?.response?.data?.message || 'No se pudo descartar el e-pedido.';
      } finally {
        this.descartando = false;
      }
    },
    formatearMonto(monto) {
      const numero = Number(monto);
      if (!Number.isFinite(numero)) return '0';
      return `${Math.round(numero).toLocaleString('es-PY', { minimumFractionDigits: 0 })} ₲`;
    },
    formatearFecha(valor) {
      if (!valor) return '—';
      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) return '—';
      return `${fecha.toLocaleDateString('es-PY')} ${fecha.toLocaleTimeString('es-PY', {
        hour: '2-digit',
        minute: '2-digit'
      })}`;
    }
  }
};
</script>

<style scoped>
/* La fila entera abre el detalle: es la acción más frecuente y no destructiva.
   Los botones de la columna Acciones usan @click.stop para no dispararlo. */
.epedido-fila {
  cursor: pointer;
}

.epedido-acciones {
  line-height: 1;
  padding: .25rem .45rem;
}

/* El menú se posiciona a la derecha del botón y por encima de la tabla: sin
   esto queda tapado por las filas siguientes dentro del .table-responsive. */
.epedido-menu {
  position: absolute;
  right: 0;
  left: auto;
  z-index: 1030;
  min-width: 12rem;
}
</style>
